// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBBti8wE13MQhLboL7YhCxiUmQPKBe60fo",
    authDomain: "app.eduventralearning.com",
    projectId: "edu-ventra",
    storageBucket: "edu-ventra.firebasestorage.app",
    messagingSenderId: "294493299056",
    appId: "1:294493299056:web:a43963de9effcaa43fefb5",
    measurementId: "G-270WFHXVFJ"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
// Initialize Firestore
const db = getFirestore(app);

export default db;
